import { Tooltip as ChakraTooltip, TooltipProps as ChakraTooltipProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import { InferPropTypes } from '../../types';

import DisplayNames from './enums';

import { forwardRef } from 'system';

// ? NOTE: We could make use of this in `Popover` if that ever ends up no longer being a strict pass-through component.
export const placementOptions = [
  'top',
  'right',
  'bottom',
  'left',
  'auto',
  'auto-start',
  'auto-end',
  'top-start',
  'top-end',
  'bottom-start',
  'bottom-end',
  'right-start',
  'right-end',
  'left-start',
  'left-end'
];

const propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.node.isRequired,
  placement: PropTypes.oneOf(placementOptions),
  openDelay: PropTypes.number,
  closeOnClick: PropTypes.bool
};

const defaultProps = {
  placement: 'top',
  openDelay: 0,
  closeOnClick: true
};

export type TooltipProps = ChakraTooltipProps & InferPropTypes<typeof propTypes, typeof defaultProps>;

const Tooltip = forwardRef<TooltipProps, 'div'>(
  (props: TooltipProps, ref): React.ReactElement => {
    return <ChakraTooltip ref={ref} {...props} />;
  }
);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
Tooltip.displayName = DisplayNames.Tooltip;

export default Tooltip;
